import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  email: '',
  googleIdToken: '',
  isRegularSignUp: false,
  isGoogleSignUp: false,
  link: '',
  mobileLink: '',
};

const appStateSLice = createSlice({
  name: 'appStateSlice',
  initialState,
  reducers: {
    setRegularSignUp(state, action) {
      Object.assign(state, initialState, {
        email: action.payload,
        isRegularSignUp: Boolean(action.payload),
      });
    },
    setGoogleSignUp(state, action) {
      Object.assign(state, initialState, {
        googleIdToken: action.payload,
        isGoogleSignUp: Boolean(action.payload),
      });
    },
    saveSmartLink(state, action) {
      state.link = action.payload.link;
      state.mobileLink = action.payload.mobileLink;
    },
  },
});

export const { setRegularSignUp, setGoogleSignUp, saveSmartLink } = appStateSLice.actions;

export default appStateSLice.reducer;
